import React from 'react';

const NoDataAvailable = () => {
    return (
        <h2 className="flex h-40 items-center justify-center text-3xl font-semibold capitalize text-muted-foreground">
            no data available
        </h2>
    );
};

export default NoDataAvailable;
